import React, { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router'

/**
 * This component does some automatic cleaning of urls for params we don't want easily seen
 */
export const UrlCleaner = () => {
  // Scrub req_token from search params
  const history = useHistory()
  const location = useLocation()
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    if (queryParams.has('req_token')) {
      queryParams.delete('req_token')
      history.replace({
        search: queryParams.toString()
      })
    }
  }, [history, location.search])

  return <></>
}
